import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fbc6846&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4fbc6846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc6846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbc6846')) {
      api.createRecord('4fbc6846', component.options)
    } else {
      api.reload('4fbc6846', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fbc6846&scoped=true&lang=pug&", function () {
      api.rerender('4fbc6846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/textInput/index.vue"
export default component.exports